import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProviderWrapper } from '@design-system/ThemeContext';

import AppRoutes from './app/AppRoutes';
import AuthBootstrap from './app/AuthBootstrap';
import Layout from './app/Layout';

function App() {
  return (
    <ThemeProviderWrapper>
      <BrowserRouter>
        <AuthBootstrap>
          <Layout>
            <AppRoutes />
          </Layout>
        </AuthBootstrap>
      </BrowserRouter>
    </ThemeProviderWrapper>
  );
}

export default App;
